
export default {
	props: {
		crumbs: {
			type: Array,
			default: () => []
		}
	},
}
